/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration200>;

/**
 * @description Parcela não encontrada
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationMutationRequestSchema =
  z.array(
    z.number().int(),
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationMutationRequest>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpiration200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsResetExtendedExpirationMutationResponse>;
